/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type PdpRespDealerDetails_viewer = {
    readonly isMessageCenterEnabled: boolean | null;
    readonly isReviewsEnabled: boolean | null;
    readonly " $fragmentRefs": FragmentRefs<"ContactDealerInlineForm_viewer" | "PdpSharedSellerTabsVariant_viewer">;
    readonly " $refType": "PdpRespDealerDetails_viewer";
};
export type PdpRespDealerDetails_viewer$data = PdpRespDealerDetails_viewer;
export type PdpRespDealerDetails_viewer$key = {
    readonly " $data"?: PdpRespDealerDetails_viewer$data;
    readonly " $fragmentRefs": FragmentRefs<"PdpRespDealerDetails_viewer">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "PdpRespDealerDetails_viewer",
  "type": "Viewer",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": "isMessageCenterEnabled",
      "name": "isEnabledByLocale",
      "args": [
        {
          "kind": "Literal",
          "name": "featureName",
          "value": "MESSAGE_CENTER"
        }
      ],
      "storageKey": "isEnabledByLocale(featureName:\"MESSAGE_CENTER\")"
    },
    {
      "kind": "ScalarField",
      "alias": "isReviewsEnabled",
      "name": "isEnabledByLocale",
      "args": [
        {
          "kind": "Literal",
          "name": "featureName",
          "value": "ORDER_FEEDBACK"
        }
      ],
      "storageKey": "isEnabledByLocale(featureName:\"ORDER_FEEDBACK\")"
    },
    {
      "kind": "FragmentSpread",
      "name": "ContactDealerInlineForm_viewer",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "PdpSharedSellerTabsVariant_viewer",
      "args": null
    }
  ]
};
(node as any).hash = '9ca63780d7a95bda52f614ac0c6fe79d';
export default node;
